<template>
  <div class="content">
    <div class="main">
      <div class="infolan">
        <ul>
          <li>
            <i class="iconfont icon-pinpai"></i>品牌大厂
          </li>
          <li>
            <i class="iconfont icon-iconfontzhizuobiaozhun023138"></i>品质保证
          </li>
          <li>
            <i class="iconfont icon-gouwuchekong"></i>一站采购
          </li>
          <li>
            <i class="iconfont icon-taocanxinxi"></i>套餐组合
          </li>
          <li>
            <i class="iconfont icon-iconzhengpin"></i>价优质保
          </li>
        </ul>
      </div>
      <div class="Productmap">
        <div class="Productmap-left">
          <div class="Bigmap bran-father">
            <img :src="datas.matimagemax" v-if="datas.matimagemax" oncontextmenu="return false;"/>
          </div>
          <div class="Smallmap">
            <ul>
              <li
                v-for="(item,index) in matimg"
                :key="index"
                @click="addClass(index,item)"
                v-bind:class="{classred:index==current}"
                v-show="item"
              >
                <div class="bran-father"><img :src="item" oncontextmenu="return false;"/></div>
              </li>
            </ul>
          </div>
        </div>
        <div class="Productmap-right">
          <div class="right-top">
            <h2>{{datas.matname}}{{datas.matgroupname}}</h2>
            <h4>{{datas.matspecil}}&nbsp;{{datas.matid}}</h4>
          </div>
          <div class="info">
            <h5>品牌: &nbsp;&nbsp;{{datas.brand}}</h5>
            <h5>分类: &nbsp;&nbsp;{{datas.matgroupname}}</h5>
            <h5>产品: &nbsp;&nbsp;{{datas.matname}}</h5>
            <h5>编码: &nbsp;&nbsp;{{datas.matid}}</h5>
            <h5>单位: &nbsp;&nbsp;{{datas.stockuom}}</h5>
            <h5>规格: &nbsp;&nbsp;{{datas.matspecil}}</h5>
            <h5>片重: &nbsp;&nbsp;{{datas.wgt}}</h5>
            <h5>箱重: &nbsp;&nbsp;{{datas.xdwgt}}</h5>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="center-left">
          产品详情
        </div>
      <div class="center-right">
      </div>
      </div>
      <div class="details">
        <p class="asp" v-html="reshtml">Using mustaches: {{ reshtml }}</p>
      </div>
      <div class="bananes"  v-loading="loading" element-loading-text="图片加载中  请稍后..." v-show="resa!==0">
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
let Base64 = require('js-base64').Base64;
export default {
  components: {
  },
  data() {
    return {
      nub: "2",
      showquote: false,
      current: 0,
      measure: [{ name: 1 }, { name: 2 }, { name: 2 }],
      datas: "",
      matimg: [],
      dataa: "",
      reshtml:'',
      loading: true,
      resa:""
    };
  },
  methods: {
    getshow(data) {
      // console.log("data", data);
      this.showquote = data;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    getshow(data) {
      // console.log("data", data);
      this.showquote = data;
    },
    mask() {
      this.showquote = false;
    },
    addClass(index, item) {
      this.current = index;
      this.datas.matimagemax = item;
    },
    getjson: async function() {
      let res = this.$route.query.resl;
      let datas = res;
      let resd = await this.exequy.getDetails(datas);
      this.datas = resd.data.data;
      this.gethtml(this.datas.htmlstr);
      this.matimg.push(
        this.datas.matimagemax,
        this.datas.matimage2max,
        this.datas.matimage2max
      );
      //  console.log('reimg',this.matimg)
    },
   gethtml: async function(htmlstr){
      let res = await this.exequy.gethtml(htmlstr)
      this.resa=res.data.code;
      // console.log('富文本',this.resa);
      this.reshtml = Base64.decode(res.data.htmlstr);
    },
  },
  created: async function() {
    let self = this;
    self.getjson();
  }
};
</script>
<style scoped>
.asp{
  width: 750px;
  margin-left: 15%;
  overflow: hidden;
  float: left;
}
.asp>>>img{
  width: 750px !important;
  margin: 0 auto;
  float: left;
}
.content {
  width: 100%;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.banane {
  width: 100%;
  height: 340px;
  
}
.bananes {
  width: 550px;
  height: 500px;
  font-size: 22px;
  color: dimgray;
  margin: 0 auto;
}
.infolan{
  margin-bottom: 2rem
}
.infolan ul {
  color: rgb(179, 29, 37);
  margin-block-start: 0px;
  margin-block-end: 0px;
  overflow: hidden;
  background: rgb(221, 221, 221);
}
.infolan ul li {
  width: 20%;
  height: 3rem;
  line-height: 3rem;
  float: left;
  font-size: 20px;
  list-style: none;
}
.infolan ul li i {
  padding-right: 8px;
}
.banane img {
  width: 100%;
  height: 100%;
}
.main {
  width: 1340px;
  margin: 0 auto;
  margin-top: 30px;
  overflow: hidden;
  margin-bottom: 4rem;
}
.center{
  width: 82%;
  float: left;
  height: 75px;
  margin-left: 15%;
  margin-bottom:25px;
}
.center-left{
  float: left;
  height: 68px;
  width: 15%;
  color: #b31d25;
  font-size: 17px;
  line-height: 67px;
  border:1px solid rgb(189, 189, 189);
  border-top: 3px solid #b31d25;
}
.center-right{
  float: left;
  height: 70px;
  width: 70%;
  border:1px solid rgb(189, 189, 189);
  border-left: none;
}
.Bigmap {
  width: 100%;
  height: 30rem;
}
.Bigmap img {
  width: 80%;
  height: 24rem;
}
.bran-father{
  position: relative;
}
.Smallmap .brand{
 width:40px; 
 height:15px; 
 background:#b31d25;
 position:absolute;
 top: 0px;
 right: 0px;
 color: #fff;
 line-height: 15px;
 font-size: 10px;
}
.Smallmap .bran-father{
  position: relative;
}
.brand{
 width:120px; 
 height:50px; 
 background:#b31d25;
 position:absolute;
 top: 0px;
 right: 0px;
 color: #fff;
 line-height: 50px;
 font-size: 23px;
}
.Productmap{
  height: 616px;
}
.Productmap-left {
  width: 40%;
  float: left;
  margin-left: 15%;
}
.Productmap-left img {
  width: 100%;
  height: 100%;
}
.Smallmap {
  width: 100%;
}
.Smallmap ul {
  padding-inline-start: 0px;
  margin-left: -1%;
}
.Smallmap ul li {
  width: 18%;
  list-style: none;
  float: left;
  margin-bottom: 18px;
  margin-left: 1%;
}
/* .classred {
  border: 1px solid #c0c0c0;
} */
.Price {
  width: 100%;
  height: 4rem;
  line-height: 4rem;
  background: #f2f2f2;
  font-size: 25px;
  color: #d9332e;
}
.Productmap-right {
  width: 42%;
  float: right;
  height: 616px;
}
.info,
.right-top {
  width: 50%;
  margin-left: 10%;
  float: left;
  text-align: left;
}
.right-top h4 {
  color: #d9332e;
  margin-top: 10%;
}
.info {
  margin-top: 2%;
  background: #dbdbdb33;
  border-radius: 15px;
  padding-left: 15px;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
